import { createStore } from "vuex";
import {
  getModule,
  Module,
  MutationAction,
  VuexModule,
} from "vuex-module-decorators";

const scheduledDeliveryInfo = createStore({
  state: {
    scheduledDeliveryInfo: null,
  },
  mutations: {
    setscheduledDeliveryInfo(state, scheduledDeliveryInfo) {
      state.scheduledDeliveryInfo = scheduledDeliveryInfo;
    },
  },
  actions: {},
  modules: {},
});

/**
 * ユーザー属性 Store
 */
@Module({
  dynamic: true,
  store: scheduledDeliveryInfo,
  name: "scheduledDeliveryStore",
})
class ScheduledDeliveryStore extends VuexModule {
  public chain_code = "";
  public shop_code_from = "";
  public shop_code_to = "";
  public scheduled_delivery_no = "";
  public processFlag = 0;

  get hasValue(): boolean {
    return (
      this.chain_code !== "" &&
      this.shop_code_from !== "" &&
      this.shop_code_to !== ""
    );
  }
  /**
   * ユーザー属性値を設定
   *
   * @param store
   */
  @MutationAction({
    rawError: true,
    mutate: [
      "chain_code",
      "shop_code_from",
      "shop_code_to",
      "scheduled_delivery_no",
      "processFlag",
    ],
  })
  async setupValue(store: {
    chain_code: string;
    shop_code_from: string;
    shop_code_to: string;
    scheduled_delivery_no: string;
    processFlag: number;
  }): Promise<
    ScheduledDeliveryStore & {
      chain_code: string;
      shop_code_from: string;
      shop_code_to: string;
      scheduled_delivery_no: string;
      processFlag: number;
    }
  > {
    return {
      ...store,
    } as ScheduledDeliveryStore & {
      chain_code: string;
      shop_code_from: string;
      shop_code_to: string;
      scheduled_delivery_no: string;
      processFlag: number;
    };
  }
}
export default getModule(ScheduledDeliveryStore, scheduledDeliveryInfo);
